<template>

<div class="main list-view no-sub-header">

	<div class="filters">

		<div v-if="showDetail">
			<button class="button neutral" @click="backToList()">Back To List</button>
		</div>
		<div v-else>
			<div class="label-group">
				<label>Start</label>
				<input type="date" v-model="filters.start_date" :max="$today().clone().format('YYYY-MM-DD')">
			</div>
			<div class="label-group">
				<label>End</label>
				<input type="date" v-model="filters.end_date" :max="$today().clone().format('YYYY-MM-DD')">
			</div>
			<div class="label-group">
				<label></label>
				<div class="button small neutral" @click="getList()">Filter Dates</div>
			</div>

			<div class="divider"></div>
			<label>Register</label>
			<select v-model="filters.device_license_id" @change="getList()">
				<option value="">All Registers</option>
				<option v-for="device in deviceLicenses" :value="device.device_license_id">{{ device.device_nickname }}</option>
			</select>

			<label>Cashier</label>
			<select v-model="filters.user_id" @change="getList()">
				<option value="">All Cashiers</option>
				<option v-for="cashier in cashiers" :value="cashier.user_id">{{ cashier.user_name }}</option>
			</select>
			<div class="divider"></div>
			<button class="button neutral" @click="clearFilters(true)">Clear Filters</button>
			<div class="divider"></div>
			<div :class="['extra-menu-item', loading ? 'disabled' : '']" @click="doExport()">Export CSV</div>
		</div>
	</div>

	<div v-if="showDetail" class="detail" style="max-width: 20em;">
        <label>Date / Time</label>
		<input type="text" readonly :value="listDetail.device_log_time" />
        <label>Code</label>
		<input type="text" readonly :value="listDetail.device_license_number" />
        <label>Nickname</label>
		<input type="text" readonly :value="listDetail.device_nickname" />
        <label>Cashier</label>
		<input type="text" readonly :value="listDetail.user_name" />
        <label>Type</label>
		<input type="text" readonly :value="listDetail.device_log_type_code" />
        <label>Amount</label>
		<input type="text" :readonly="getUser.user_type_code.indexOf('MANAGER') < 0 || (listDetail.device_log_type_code != 'OPEN' && listDetail.device_log_type_code != 'CLOSE')" v-model="listDetail.amount" />
		<div v-if="getUser.user_type_code.indexOf('MANAGER') > -1 && (listDetail.device_log_type_code == 'OPEN' || listDetail.device_log_type_code == 'CLOSE')">
			<div class="button neutral inline" @click="confirmChangeAmount = true">Save {{ listDetail.device_log_type_code }} Amount</div>
		</div>
	</div>

	<div v-else class="list report-list">

	    <div v-if="list.length == 0" class="empty-list">
	        This list is empty
	    </div>

		<div v-else>
			<div class="detail-sub-header right">
				<pagination v-if="showPagination" :paging="paging" @updatePage="goToPage"></pagination>
			</div>

			<table class="data-list" cellpadding="0" cellspacing="0">
				<thead>
					<tr>
						<th class="list">Date / Time</th>
						<th class="list left">Code</th>
						<th class="list left">Nickname</th>
						<th class="list left">User</th>
						<th class="list left">Type</th>
						<th class="list right">Amount</th>
					</tr>
				</thead>
				<tr v-for="item in list" class="clickable-list-item" @click="getItem(item)">
					<td class="list left">{{ item.device_log_time }}</td>
					<td class="list left">{{ item.device_license_number }}</td>
					<td class="list left">{{ item.device_nickname }}</td>
					<td class="list left">{{ item.user_name }}</td>
					<td class="list left">{{ item.device_log_type_code }}</td>
					<td class="list right">{{ $formatCurrency(item.amount) }}</td>
				</tr>
			</table>
		</div>
	</div>

	<div v-if="confirmChangeAmount" class="modal">
		<div class="inner">
			<h2>Change {{ listDetail.device_log_type_code }} Amount</h2>
			<div class="content">
				<p>Are you sure you want to change the {{ listDetail.device_log_type_code.toLowerCase() }} amount for this register?</p>
				<div v-if="modalMessage" class="message">{{ modalMessage }}</div>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="confirmChangeAmount = false">Cancel</div>
				<div :class="['button', saving ? 'disabled' : 'neutral', 'spaced']" @click="saveAmount()">Yes, Change Amount</div>
			</div>
		</div>
	</div>

	<message-modal v-if="message" :message="message" :loading="loading" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

	<iframe id="download" src="" style="display: none;"></iframe>

</div>

</template>

<script>
export default {
	name: 'register-logs',
    components: {
    },
	data() {
		return {
            loading: false,
			saving: false,
            message: '',
            messageStatus: '',
            messageTimeout: 0,
            list: [],
			paging: {},
			showPagination: true,
            filters: {},
			deviceLicenses: [],
			cashiers: [],
            showDetail: false,
			listDetail: {},
			gettingExport: false,
			confirmChangeAmount: false,
			modalMessage: ''
		}
	},
	created() {
		this.getRegisters()
		this.clearFilters(true)
	},
	methods: {
		clearFilters(getList) {
			this.filters = {
				page: 1,
				start_date: '',
				end_date: '',
				device_license_id: '',
				user_id: '',
				do_export: false
			}
			if (this.$route.query.start) {
				this.filters.start_date = this.$route.query.start
			} else {
				var oneMonthAgo = new Date()
				oneMonthAgo.setMonth(oneMonthAgo.getMonth() -1)
				this.filters.start_date = oneMonthAgo.toISOString().slice(0,10)
			}
			if (this.$route.query.end) {
				this.filters.end_date = this.$route.query.end
			} else {
				this.filters.end_date = new Date().toISOString().slice(0,10)
			}
			if (getList) {
				this.getList(1)
			}
		},
		getRegisters() {
			this.apiCall({ destination: 'get_list_device_licenses', data: { include_cashiers: true } }).then(obj => {
				if (obj.status == 'success') {
					this.deviceLicenses = obj.list
					this.cashiers = obj.cashiers
				}
			}).catch(err => {
				console.log(err)
			})
		},
		getList() {
            if (this.loading) { return }
			this.loading = true
			if (this.filters.do_export) {
				this.message = 'Generating CSV for ' + this.paging.total_items + ' items...'
			} else {
				this.message = 'Generating report...'
			}
			this.apiCall({ destination: 'get_list_device_log', data: this.filters }).then(obj => {
				this.loading = false
				this.messageStatus = obj.status
				if (this.filters.do_export) {
					this.filters.do_export = 0
					// accommodate live server filecache latency
					setTimeout(() => {
						this.message = 'Downloading CSV...'
						document.getElementById("download").src = obj.download_url
						this.messageTimeout = 2000
					}, 500)
				} else {
					this.list = obj.list
					this.paging = obj.paging
					this.message = ''
				}
			}).catch(err => {
				console.log(err)
			})
		},
		doExport() {
			this.filters.do_export = true
			this.getList()
		},
		getItem(item) {
			this.listDetail = item
			this.showDetail = true
		},
		saveAmount() {
			if (this.saving) { return }
			if (this.listDetail.amount == '' || isNaN(this.listDetail.amount)) {
				this.modalMessage = 'Please enter an amount'
				return
			}
			this.saving = true
			this.modalMessage = 'Saving amount...'
			this.apiCall({ destination: 'save_item_device_license_amount', data: this.listDetail }).then(obj => {
				this.saving = false
				if (obj.status == 'success') {
					this.modalMessage = 'Amount saved!'
					setTimeout(() => {
						this.confirmChangeAmount = false
					}, 1500)
				} else {
					this.modalMessage = obj.message
				}
			}).catch(err => {
				console.log(err)
			})

		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		backToList() {
			this.showDetail = false
			this.listDetail = {}
		}
	}
}
</script>
